import store from "@/store";
import { initGlobalState } from "qiankun";
export const PARAMS = {
  TOKEN: store.state.TOKEN,
  USER_INFO: store.state.USER_INFO,
};

export const ACTIONS = initGlobalState(PARAMS);
